import BookmarksActions from "@redux/feature/Bookmarks/actions/BookmarksActions";
export default (function () {
    return {
        bookmarks: new BookmarksActions(),
    };
});
